/**
 * One place that decides whether BOS is allowed to make sound.
 *
 * BOS is MUTED BY DEFAULT. Voice is opt-in, never opt-out.
 *
 * Voice used to be on by default with no way to turn it off. The first customer
 * said so on her onboarding call: "there's nothing that gives me the opportunity
 * to mute it from talking back to me. If I just wanted to have chat". A later
 * reply reading "done" aloud startled her mid-call.
 *
 * Every surface that can speak must consult isVoiceEnabled() before producing
 * audio, so a muted install is silent everywhere rather than silent in the one
 * place someone remembered to check.
 */
const KEY = 'boss_voice_enabled';

/** Muted unless the owner explicitly opted in. Absent value means muted. */
export function isVoiceEnabled(): boolean {
  try {
    return localStorage.getItem(KEY) === '1';
  } catch {
    return false; // storage blocked: stay silent
  }
}

export function setVoiceEnabled(enabled: boolean): void {
  try {
    localStorage.setItem(KEY, enabled ? '1' : '0');
  } catch {
    /* storage blocked */
  }
  if (!enabled) stopSpeaking();
}

/** Silence anything already talking. Safe when nothing is. */
export function stopSpeaking(audio?: HTMLAudioElement | null): void {
  try { window.speechSynthesis?.cancel(); } catch { /* unsupported */ }
  try { audio?.pause(); } catch { /* already gone */ }
}
